import { Button, Tooltip, Typography, useTheme } from "@mui/material";

type ActionMenuButtonProps = {
  Icon: MuiIconType;
  onClick: () => void;
  disabled?: boolean;
  text: string;
  tooltipText?: string;
};

const ActionMenuButton = ({ Icon, onClick, disabled, text, tooltipText }: ActionMenuButtonProps) => {
  const theme = useTheme();

  const button = (
    <Button
      variant="text"
      onClick={onClick}
      aria-label={text}
      disabled={disabled}
      sx={{ justifyContent: "flex-start", alignItems: "flex-start" }}
    >
      <Icon color={disabled ? theme.palette.text30.main : theme.palette.text50.main} size={24} />
      <Typography variant="body.medium.regular" color={disabled ? "text30.main" : "text40.main"}>
        {text}
      </Typography>
    </Button>
  );
  return (
    <>
      {disabled ? (
        <Tooltip
          title={tooltipText}
          placement="left"
          id="tooltip"
          arrow
          slotProps={{
            popper: {
              modifiers: [
                {
                  name: "offset",
                  options: {
                    offset: [0, 8],
                  },
                },
              ],
            },
          }}
        >
          <span>{button}</span>
        </Tooltip>
      ) : (
        button
      )}
    </>
  );
};

export { ActionMenuButton };
